import {IItemShopSimple} from "@/models/item/ItemShopModels";
import {UnitOfMeasure} from "@/helpers/constants";

export default class ItemQuantityHelper {

	public static stepAmount(item: IItemShopSimple | null): number {
		if (item === null) {
			return 1;
		}
		if (item.isSalesUnitFixed) {
			return item.salesUnitQuantity;
		}
		return item.salesUnitOfMeasure === UnitOfMeasure.unitMeter ? 0.5 : 1;
	}
}